/**
 * Convert To Currency Format
 * @param num{number} - number input
 * @param deg - deg to fixed (decimal)
 * @return {number}
 */
const currFormat = (num = 0, deg = 2) => Number((+num).toFixed(deg));
/**
 * Formaterr String Number to Currency Format xx,xxx,xxx
 * @param value - value to replace
 * @return {string}
 */
const formatter = (value = "") => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
/**
 * Parsing Data to Number format with RegEx
 * @param value{string} - value to replace
 * @return {string} - input 1000 return 1,000
 */
const parserNumber = (value = '') => value.replace(/\$\s?|(,*)/g, '')
/**
 * Convert Text to lowercase
 * @param str{string}
 * @return {string|string}
 */
const strToLowerCase = (str = "") => str && (str || "").trim().toLowerCase();

/**
 * currencyFormat Convertion
 * @param param {string|number}
 * @param tf{number}
 * @return {string}
 */
const currencyFormat = (param = 0, tf = 2) =>  Number(param)
  .toFixed(tf)
  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

/**
 * Get First Index
 * @param data{any} - Data want to get first index
 * @param param{string} - data 1st index
 * @return {string|*}
 */
const getFirstData = (data = [], param = "") => {
  if (data && data.length > 0 && param !== "") {
    return data[0][param] || ""
  }
  return ""
}

const IntlCurrencyFormat = (value=0, deg=2) => new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  minimumIntegerDigits: 2,
  minimumFractionDigits: deg ?? 0,
}).format(+value || 0);

const localCompare = (param = '', {prev, next}, type='text') => {
  switch (type) {
    case "text":
      return prev[param].localeCompare(next[param]);
    case "number":
      return prev[param] - next[param];
    default:
      return prev[param].localeCompare(next[param]);
  }
}

const groupBy = (arr=[], prop) => Object.values(
  arr.reduce((aggregate, item) => {
    const val = item[prop];
    if (!aggregate[val]) {
      aggregate[val] = {
        [prop]: val,
        data: []
      };
    }
    aggregate[val].data.push(item);
    return aggregate;
  }, {})
);


function uniqueObjectsByProperty(arr, property) {
  const uniqueObjects = [];
  const uniquePropertyValues = new Set();

  arr.forEach(obj => {
    const value = obj[property];
    if (!uniquePropertyValues.has(value)) {
      uniquePropertyValues.add(value);
      uniqueObjects.push(obj);
    }
  });

  return uniqueObjects;
}


export {
    currencyFormat,
    currFormat,
    formatter,
    getFirstData,
    groupBy,
    IntlCurrencyFormat,
    localCompare,
    parserNumber,
    strToLowerCase,
    uniqueObjectsByProperty,
};

